import { render, staticRenderFns } from "./_side-view.vue?vue&type=template&id=d952b090&scoped=true"
import script from "./_side-view.vue?vue&type=script&lang=js"
export * from "./_side-view.vue?vue&type=script&lang=js"
import style0 from "./_side-view.vue?vue&type=style&index=0&id=d952b090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d952b090",
  null
  
)

export default component.exports